import { Box, Button, Typography } from '@mui/material';
import AppShell, { SettingsGroup } from '../components/layout/AppShell';
import DesignSystem from '../designSystem';
import { useThemeMode } from '../contexts/ThemeModeContext';
import type { ThemePreference } from '../config/themeMode';
import { useT } from '../i18n/useT';

const OPTIONS: { value: ThemePreference; labelKey: 'appearanceSystem' | 'appearanceLight' | 'appearanceDark' }[] = [
  { value: 'system', labelKey: 'appearanceSystem' },
  { value: 'light', labelKey: 'appearanceLight' },
  { value: 'dark', labelKey: 'appearanceDark' },
];

export default function AppearanceSettingsPage() {
  const t = useT();
  const { preference, setPreference } = useThemeMode();

  return (
    <AppShell title={t('appearance')} showBackButton maxWidth="sm" showCompanion={false}>
      <Typography sx={{ mb: 2, fontSize: 14, color: DesignSystem.colors.textSecondary }}>
        {t('appearanceHint')}
      </Typography>
      <SettingsGroup>
        <Box sx={{ p: 2.5, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {OPTIONS.map(({ value, labelKey }) => (
            <Button
              key={value}
              variant={preference === value ? 'contained' : 'outlined'}
              onClick={() => setPreference(value)}
              sx={{ textTransform: 'none', borderRadius: 999, boxShadow: 'none' }}
            >
              {t(labelKey)}
            </Button>
          ))}
        </Box>
      </SettingsGroup>
    </AppShell>
  );
}
